<template>
  <div class="tab-bar">
    <div  v-for="(item, index) in tabs" 
      :key="index"
      class="tab-item"
      @click="switchTab(index)"
    >

      <div class="inline relative center middle">
            <img class="item_img middle" :src="currentIndex === index ? item.selectedIcon : item.icon" />
            <span :class="'item_title ' + (currentIndex === index?'item_title_active':'') ">{{ item.title }}</span>
            <!-- 右上数字 -->
            <div v-if="item.badge && item.badge>0" class="item_right_count">{{item.badge}}</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  props: {
    tabs: {
      type: Array,
      default: () => [
        { title: '购物车', icon: 'icon-cart', selectedIcon:'', path: '/cart', badge:0 },
      ]
    },
    defaultActive: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentIndex: this.defaultActive
    }
  },

  watch: {
    defaultActive: {
        handler(newVal, oldVal){
          console.log("uuuuuuuuuuuuuuuu", newVal, oldVal);
          if(newVal!==oldVal)this.currentIndex=newVal;
        }
    }
  },

  methods: {
    switchTab(index) {
      console.log("switchTab",index, this.currentIndex);
      if(this.currentIndex === index){
        console.log("导航到当前已在页面，back");
        return;
      }
      this.currentIndex = index
      this.$emit('tab-change', index, this.tabs[index])
      // 路由跳转
      this.$router && this.$router.push(this.tabs[index].path)
    }


  }
}
</script>

<style scoped>

.tab-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin-left: auto;margin-right: auto;
  max-width: var(--h5-max-width);/**calc(var(--h5-max-width) + var(--left-window-width));*/
  height: 50px;
  background: var(--bg-main);
  display: flex;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
  z-index: 1000;
}


/* 竖屏 */
@media (orientation: portrait) {
 .tab-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; 
    cursor: pointer;
    transition: all 0.3s;
  }
  .item_title{
    display: block;
  }
}
/* 横屏 */
@media (orientation: landscape) {
 .tab-item {
    flex: 1;
    display: flex;
    flex-direction:row;
    align-items: center;
    justify-content: center; 
    cursor: pointer;
    transition: all 0.3s;
  }
  .item_title {
    margin-left: 3px;
  }
}

.item_img {
  width: 20px;
  height: 20px;
}
.item_title {
  line-height: 120%;
}

.item_title_active {
  color: #ff0000;
}

.item_right_count{
  width:20px;
  height:20px;
  position: absolute;
  right: -20px;
  max-width: 20px;
  border-radius: 50%;
  background: #ff0000;
  color: #fff;
  top:0px;
  text-align: center;
  line-height: 20px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/mytabbar.vue